import React, { useState } from "react";
import {
  decodeFiltersFromQueryString,
  getSelectedFilterItemArr,
  mergeAppliedFilters,
  removeFilters,
} from "../../utils/UtilityMethod";
import MobileCatalogFilterItem from "./MobileCatalogFilterItem";

  /**
   * BOC
   * Support#138967-Filters Logic
   * author Maanik Arya
   * date 21-Jun-2023
   * use_of_code:- The sortOptions is used to store the sort options.
   * The sortCallback is used to handle the sort functionality.
   */
function MobileCatalogFilter({ cbCallback, filters, searchParams, filterQs , sortOptions ,sortCallback }) {
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [switchFilterSection, setSwitchFilterSection] =
    useState("manufacturer");
  const [filtersSelectedArr, setFiltersSelectedArr] = useState([]);
  const [filtersToApply, setFiltersToApply] = useState([]);
  const [preSelectedFilter, setPreSelectedFilter] = useState([]);
  /**
   * BOC
   * Support#138967-Filters Logic
   * author Maanik Arya
   * date 21-Jun-2023
   * use_of_code:- This code is used to handle the sort functionality.
   * The sortSelected state is used to display the sort section whenever click on the sort button.
   * The sortValue state is used to store the selected sort value.
   */
  const [sortSelected , setSortSelected] = useState(false);
  const [sortValue, setSortValue] = useState(searchParams.get("sort-by") || "");
  const [windowOffset, setwindowOffset] = useState();
  /** EOC */

  // let filterQs = searchParams.get("f") || "";
  const toggle = () => {
    if (!isFilterModalOpen) {
      setFiltersSelectedArr(getSelectedFilterItemArr(filterQs));
      decodeFiltersFromQueryString(filterQs).then((data) => {
        setFiltersToApply(data);
        setPreSelectedFilter(data);
      });
      setwindowOffset(window.scrollY);
      document.body.setAttribute('style',`position: fixed; top: -${window.scrollY}px;left:0;right:0;`);
    }else{
      document.body.setAttribute('style',''); 
      window.scrollTo({
        left: 0,
        top: windowOffset || 0,
        behavior: "instant",
      });
    }
    setIsFilterModalOpen(!isFilterModalOpen);
  };

  const refreshFilterClick = () => {    
    setFiltersSelectedArr([]);
    setFiltersToApply([]);
  };

  const onClickFilterItem = (item, isChecked) => {
    if (isChecked) {
      var temp = [...filtersSelectedArr,item?.items[0]?.url_slug];
      setFiltersSelectedArr(temp);
      mergeAppliedFilters([...filtersToApply], item).then((res) => {
        setFiltersToApply(res);
      });
    } else {      
      var deleteIndex = filtersSelectedArr.indexOf(item?.items[0]?.url_slug);
      setFiltersSelectedArr((deleteItem) => deleteItem.filter((_,index) => index !== deleteIndex));
      removeFilters([...filtersToApply], item).then((res) => {
        setFiltersToApply(res);
        decodeFiltersFromQueryString(filterQs).then((filterdata) => {
          setPreSelectedFilter(filterdata);
        });
      });
    }
  };

  const onApplyFilter = () => {
    toggle();
    /**
     * BOC
     * Support#138967-Filters Logic
     * author Maanik Arya
     * date 21-Jun-2023
     * use_of_code:- The sortCallback is used to handle the sort functionality.
     * Unnecessary the sortCallback is called whenever click on the apply button.So, the sortCallback is called only when the sortValue is not empty.
     */
    if(sortValue !== "")
    sortCallback(sortValue);
    /** EOC */
    if(JSON.stringify(preSelectedFilter) !== JSON.stringify(filtersToApply)){
      cbCallback(filtersToApply);
    }    
  };

  return (
    <>
      {/** The Refine Icon  
       * Whenever click on the Refine Icon then the Filter PopUp will be open.
       * 
       * /**
      * BOC
      * Support#138967-Filters Logic
      * author mohammad Meraj
      * date 18-July-2023
      * use_of_code:- updated the code for fix the issue of the filter icon.
      */}
      <button className="btn-blank" onClick={toggle} style={{marginLeft:"-12px"}}>
        {/* <img
          src={process.env.PUBLIC_URL + "/assets/images/icons/filter.png"}
          alt=""
        /> */}
        {/* Filter */}
        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="currentColor" class="bi bi-filter"
                        viewBox="0 0 16 16">
                        <path
                        d="M6 10.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5zm-2-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm-2-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5z" />
        </svg>
      </button>

      {/** The Filter PopUp 
       * The Filter PopUp will be open whenever click on the Refine Icon.
      */}
      <div
        className="newsletter fp filter filter2"
        id="filter"
        style={{ display: isFilterModalOpen ? "block" : "none" }}
      >
        <div className="bg"></div>
        <div className="center-box">
          <div className="newsletter-heading">
            <h3>Filter</h3>
            <button onClick={toggle} className="btn-blank clos-btn">
              <img
                src={
                  process.env.PUBLIC_URL +
                  "/assets/images/icons/Cross-Button.png"
                }
                className="close-btn-newsletter"
                alt=""
              />
            </button>
            <button
              className="btn-blank relod-btn"
              onClick={refreshFilterClick}
            >
              <img
                src={
                  process.env.PUBLIC_URL +
                  "/assets/images/icons/Refresh-Button.png"
                }
                className="close-btn-newsletter"
                alt=""
              />
            </button>
          </div>
          <div className="bottom-spacer-wide"></div>
          <div className="newsletter-body mt-10">
            <div className="apply-button">
              <button
                className="btn-primary"
                type="button"
                onClick={onApplyFilter}
              >
                APPLY
              </button>
            </div>
            <div className="filter-box-mobile">
              <div className="left-panel text-black text-left">
                <ul>
                  {filters.map((filter) => {
                  /**
                   * @BOC
                   * @Support #157051-Implement Changes On Staging Server Such that Filters are Listed on Category Page from Typesense
                   * @author Mohammad Meraj
                   * @date 02-Jan-2025
                   * @use_of_code: The category is now displayed in the filters section, which was not included previously.
                   * This change ensures that categories are treated as part of the filters, providing users with more options to refine their search directly from the filters section.
                   */
                    // if (filter?.id === "category") {
                    //   return null;
                    // }
                    /**
                     * EOC
                     */
                    return (
                      <li
                        key={`switch-filter-${filter.id}`}
                        onClick={() => {setSwitchFilterSection(filter.id);  setSortSelected(false)}}
                        className={
                          switchFilterSection === filter.id ? "active" : ""
                        }
                      >
                        {filter.title || ""}
                      </li>
                    );
                  })}
                  <li 
                    onClick={() => { setSortSelected(true); setSwitchFilterSection(""); }}
                    className={
                      switchFilterSection === ""? "active" : ""
                    }
                    >
                        Sort                        
                  </li>
                </ul>
              </div>
              <div className="right-panel text-black bg-white">
                {filters.map((filter, indx) => {
                  /**
                   * @BOC
                   * @Support #157051-Implement Changes On Staging Server Such that Filters are Listed on Category Page from Typesense
                   * @author Mohammad Meraj
                   * @date 02-Jan-2025
                   * @use_of_code: The category is now displayed in the filters section, which was not included previously.
                   * This change ensures that categories are treated as part of the filters, providing users with more options to refine their search directly from the filters section.
                   */
                  // if (filter?.id === "category") {
                  //   return null;
                  // }
                  /**
                   * EOC
                   */
                  return (
                    <div
                      key={`filter-${indx}`}
                      className={`${filter.id}-filter text-black`}
                      id={`${filter.id}-filter-mobile`}
                      style={{
                        display:
                          filter.id === switchFilterSection ? "block" : "none",
                      }}
                    >
                      <MobileCatalogFilterItem
                        onClickFilterItem={onClickFilterItem}
                        filter={filter}
                        filtersSelectedArr={filtersSelectedArr}
                      />
                    </div>
                  );
                })}

                { sortSelected && (
                  <>
                      {sortOptions?.map(({ title, id }) => { 
                          return (
                              <>
                              { /** The below code is for display the Sort SEction in the Filter PopUp. */}
                              <div className="form-check filter-check">
                                  <input
                                      className="form-check-input"
                                      type="radio"
                                      value=""
                                      id={`sor_radio_${id}`}
                                      checked={sortValue === id}
                                      onChange={() => {
                                          setSortValue(id);
                                        }}
                                  />

                                  <label
                                      className={`form-check-label text-left text-black`}
                                      htmlFor={`sor_radio_${id}`}
                                  >
                                      {title}
                                  </label>
                              </div>
                              </>
                          )
                      })}
                  </>
                  )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default MobileCatalogFilter;
